<div class="cont">
    <mat-icon id="close" svgIcon="cross" (click)="close()"></mat-icon>
    <app-admin-profile (close)="close()"></app-admin-profile>
</div>